<div class="flex-cards mat-typography">
    @for (event of sepObjects; track event.id) {
    <div>

        <app-flip-card>
            <!-- FRONT -->
            <app-flip-card-front>
                <div class="top-container">
                    <img mat-card-image class="front" [src]="event.fileReference_cardThumbnail" [alt]="event.imgAltText">
                </div>
            </app-flip-card-front>

            <content-at-front-arrow class="front-content">
                <div class="title" [innerHTML]="event.title"></div>
            </content-at-front-arrow>

            <!-- BACK -->
            <app-flip-card-back>
                <div class="top-container">
                    <div class="back" [innerHTML]="event.content"></div>
                </div>
            </app-flip-card-back>

            <content-at-back-arrow class="back-content">
            </content-at-back-arrow>

        </app-flip-card>

        <button class="select-btn" matButton="outlined" color="secondary" (click)="navigate(event.selectNavUrl)">Select</button>
    </div>
    } @empty {
    <p>special-enrollment-event-selector-cards lacks events</p>
    }
</div>